import React from 'react';
import type { ImageBlock as ImageBlockType } from '../../../types';

const ImageBlock: React.FC<{ block: ImageBlockType }> = ({ block }) => (
    <div style={{ margin: '0.8rem 0' }}>
        <img
            src={block.src}
            alt={block.alt || ''}
            style={{ maxWidth: '100%', height: 'auto', display: 'block' }}
        />
    </div>
);
export default ImageBlock;
